function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrikeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.381,
    height: 12,
    viewBox: "0 0 14.381 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11093",
    d: "M18.381 11.383h-6.018a23.96 23.96 0 0 0-.8-.2c-1.682-.4-2.634-.689-2.634-2.051A1.719 1.719 0 0 1 9.4 7.845a2.87 2.87 0 0 1 1.8-.653A3.263 3.263 0 0 1 14.321 8.6l.968-.707a4.478 4.478 0 0 0-4.093-1.9 4.058 4.058 0 0 0-2.637 1 2.893 2.893 0 0 0-.83 2.137 2.62 2.62 0 0 0 1.039 2.252H4v1.2h8.18c1.179.342 1.883.786 1.9 2.012a1.869 1.869 0 0 1-.517 1.434 3.49 3.49 0 0 1-2.229.748 3.975 3.975 0 0 1-3.083-1.613l-.919.77a5.109 5.109 0 0 0 3.983 2.042h.06a4.6 4.6 0 0 0 3.025-1.09 3.043 3.043 0 0 0 .878-2.309 2.967 2.967 0 0 0-.689-1.994h3.79z",
    transform: "translate(-4 -5.974)",
    style: {
      fill: "#231f20"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikeBlack);
export default __webpack_public_path__ + "static/media/StrikeBlack.ea2b7c7c8cf394ff826434425ba69325.svg";
export { ForwardRef as ReactComponent };